import React from 'react'
import styles from './JSONViewer.scss'
import blockSizes from '../../../App/blockSizes.scss'
import cx from 'classnames'

export const JSONViewer = ({block}) => (
  <div className={cx(blockSizes.normalBlock, styles.JSONViewer)}>
    <pre>
      {JSON.stringify(block.getData().toJS(), null, '  ')}
    </pre>
  </div>
)
